import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
// import "../css/CustomerStatementPreview.css";
import { API_BASE_URL } from "../config";

const CustomerStatementPreview = ({ customerUniqueId, accountNumber }) => {
  const [transactions, setTransactions] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!customerUniqueId || !accountNumber) return;

    const fetchTransactions = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/getModelData/transactions`,
          {
            params: {
              fields:
                "id,managerId,transactionType,accountNumber,customerUniqueId,amount,narration,date,debitCredit,createdAt",
              filter: JSON.stringify({ accountNumber }),
              sort: "-date",
              limit: 150,
            },
          }
        );

        if (Array.isArray(response.data.data)) {
          setTransactions(response.data.data);
        } else {
          setError("Unexpected data format received");
          setTransactions([]);
        }
      } catch (err) {
        console.error("Error fetching transactions: ", err);
        setError("Failed to fetch transactions");
      }
      setLoading(false);
    };

    fetchTransactions();
  }, [accountNumber]);

  // Process transactions to calculate balances
  const processedTransactions = useMemo(() => {
    if (transactions.length === 0) return [];

    // Sort transactions by date ascending
    const sorted = [...transactions].sort((a, b) => {
      const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split("-");
        return new Date(`${year}-${month}-${day}`);
      };
      return parseDate(a.date) - parseDate(b.date);
    });

    let currentBalance = 0;
    return sorted.map((tx) => {
      const openingBalance = currentBalance;
      const isCredit = tx.debitCredit?.toLowerCase() === "credit";
      const credit = isCredit ? tx.amount : 0;
      const debit = !isCredit ? tx.amount : 0;
      const closingBalance = openingBalance + credit - debit;
      currentBalance = closingBalance;

      return {
        ...tx,
        openingBalance,
        credit,
        debit,
        closingBalance,
      };
    });
  }, [transactions]);

  // Calculate available balance (last closing balance)
  const availableBalance =
    processedTransactions.length > 0
      ? processedTransactions[processedTransactions.length - 1].closingBalance
      : 0;

  useEffect(() => {
    if (!customerUniqueId || !accountNumber) {
      setCustomerDetails(null); // Clear details if input is empty
      return;
    }

    const fetchCustomerDetails = async () => {
      setError(""); // Reset error state before fetching
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/getModelData/personal_details`,
          {
            params: {
              fields:
                "name,age,mobileNumber,permanentStreetAddress,customerProfileImage",
              filter: JSON.stringify({ customerUniqueId }),
            },
          }
        );

        if (response.data.data && response.data.data.length > 0) {
          setCustomerDetails(response.data.data[0]);
        } else {
          setCustomerDetails(null); // ✅ Clear previous details if new data isn't found
          setError("Customer details not found");
        }
      } catch (err) {
        console.error("Error fetching customer details: ", err);
        setCustomerDetails(null); // ✅ Ensure no old data lingers on error
        setError("Failed to fetch customer details");
      }
    };

    fetchCustomerDetails();
  }, [customerUniqueId, accountNumber]); // ✅ Include both dependencies

  return (
    <div className="statement-preview">
      {/* Customer details section unchanged */}
      {customerDetails && (
        <div className="customer-info">
          <img
            src={`${API_BASE_URL}/images/${customerDetails.customerProfileImage}`}
            alt="Profile"
            className="profile-image"
          />
          <div>
            <h3>{customerDetails.name}</h3>
            <p>Age: {customerDetails.age}</p>
            <p>Mobile: {customerDetails.mobileNumber}</p>
            <p>Address: {customerDetails.permanentStreetAddress}</p>
          </div>
        </div>
      )}

      <h3>All Transactions</h3>
      <h4>Available Balance: ₹{availableBalance.toFixed(2)}</h4>

      {!loading && transactions.length > 0 && (
        <div className="transactions-container">
          <table className="transactions-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Opening Balance</th>
                <th>Credit</th>
                <th>Debit</th>
                <th>Closing Balance</th>
              </tr>
            </thead>
            <tbody>
              {processedTransactions.map((tx) => (
                <tr key={tx.id}>
                  <td>{tx.date}</td>
                  <td>{tx.narration || "N/A"}</td>
                  <td>{tx.openingBalance.toFixed(2)}</td>
                  <td>{tx.credit.toFixed(2)}</td>
                  <td>{tx.debit.toFixed(2)}</td>
                  <td>{tx.closingBalance.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CustomerStatementPreview;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../css/CustomerStatementPreview.css";
// import { API_BASE_URL } from "../config";

// const CustomerStatementPreview = ({ customerUniqueId, accountNumber }) => {
//   const [transactions, setTransactions] = useState([]);
//   const [customerDetails, setCustomerDetails] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (!customerUniqueId || !accountNumber) return;

//     const fetchTransactions = async () => {
//       setLoading(true);
//       setError("");

//       try {
//         const response = await axios.get(
//           `${API_BASE_URL}/api/getModelData/transactions`,
//           {
//             params: {
//               fields:
//                 "id,managerId,transactionType,accountNumber,customerUniqueId,amount,narration,date,debitCredit,createdAt",
//               filter: JSON.stringify({ accountNumber }),
//               sort: "-date",
//               limit: 150,
//             },
//           }
//         );

//         if (Array.isArray(response.data.data)) {
//           setTransactions(response.data.data);
//         } else {
//           setError("Unexpected data format received");
//           setTransactions([]);
//         }
//       } catch (err) {
//         console.error("Error fetching transactions: ", err);
//         setError("Failed to fetch transactions");
//       }
//       setLoading(false);
//     };

//     fetchTransactions();
//   }, [accountNumber]);

//   useEffect(() => {
//     if (!customerUniqueId || !accountNumber) {
//       setCustomerDetails(null); // Clear details if input is empty
//       return;
//     }

//     const fetchCustomerDetails = async () => {
//       setError(""); // Reset error state before fetching
//       try {
//         const response = await axios.get(
//           `${API_BASE_URL}/api/getModelData/personal_details`,
//           {
//             params: {
//               fields:
//                 "name,age,mobileNumber,permanentStreetAddress,customerProfileImage",
//               filter: JSON.stringify({ customerUniqueId }),
//             },
//           }
//         );

//         if (response.data.data && response.data.data.length > 0) {
//           setCustomerDetails(response.data.data[0]);
//         } else {
//           setCustomerDetails(null); // ✅ Clear previous details if new data isn't found
//           setError("Customer details not found");
//         }
//       } catch (err) {
//         console.error("Error fetching customer details: ", err);
//         setCustomerDetails(null); // ✅ Ensure no old data lingers on error
//         setError("Failed to fetch customer details");
//       }
//     };

//     fetchCustomerDetails();
//   }, [customerUniqueId, accountNumber]); // ✅ Include both dependencies

//   const availableBalance = transactions.reduce((balance, tx) => {
//     return tx.debitCredit.toLowerCase() === "credit"
//       ? balance + tx.amount
//       : balance - tx.amount;
//   }, 0);

//   return (
//     <div className="statement-preview">
//       {customerDetails && (
//         <div className="customer-info">
//           <img
//             src={`${API_BASE_URL}/images/${customerDetails.customerProfileImage}`}
//             alt="Profile"
//             className="profile-image"
//           />
//           <div>
//             <h3>{customerDetails.name}</h3>
//             <p>Age: {customerDetails.age}</p>
//             <p>Mobile: {customerDetails.mobileNumber}</p>
//             <p>Address: {customerDetails.permanentStreetAddress}</p>
//           </div>
//         </div>
//       )}
//       <h3>All Transactions</h3>
//       <h4>Available Balance: ₹{availableBalance}</h4>
//       {loading && <p>Loading transactions...</p>}
//       {error && <p className="error">{error}</p>}
//       {!loading && transactions.length === 0 && <p>No transactions found.</p>}
//       {!loading && transactions.length > 0 && (
//         <div className="transactions-container">
//           <table className="transactions-table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Description</th>
//                 <th>Transaction Type</th>
//                 <th>Customer ID</th>
//                 <th>Amount</th>
//                 <th>Credit/Debit</th>
//               </tr>
//             </thead>
//             <tbody>
//               {transactions.map((tx) => (
//                 <tr key={tx.id}>
//                   <td>{tx.date}</td>
//                   <td>{tx.narration || "N/A"}</td>
//                   <td>{tx.transactionType}</td>
//                   <td>{tx.customerUniqueId}</td>
//                   <td>₹{tx.amount}</td>
//                   <td>
//                     {tx.debitCredit.toLowerCase() === "credit" ? (
//                       <span className="credit">deposit</span>
//                     ) : (
//                       <span className="debit">withdraw</span>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomerStatementPreview;
